/**
 * Static policy documents shipped from `public/`.
 *
 * Kept in one place because the same PDF is linked from three unrelated
 * surfaces — the public Race Details page and the two consent checkboxes in
 * the Commitment and PWD registration forms. The file is replaced in place
 * when the terms are revised (it has been, three times), so a single constant
 * is the only thing keeping those three links pointing at the same document.
 */
export const TERMS_URL = "/BBCxTEKLRR2026-Terms-and-Conditions.pdf";
